export default __webpack_public_path__ + "static/media/random8.3ff40e72.jpeg";